import gql from 'graphql-tag'

export default gql`mutation updateEditUser($data: UserInput) {
    updateEditUser(data: $data) @client
}`